<ng-container *transloco="let t">
  <div
    id="origination-coming-soon-card"
    class="flex flex-col gap-4"
    [attr.aria-label]="t('originationComingSoonAriaLabel')"
  >
    <div id="origination-coming-soon-hero" class="card-base flex flex-col gap-4">
      <div id="origination-coming-soon-heading" class="flex flex-col gap-2">
        <h2
          id="origination-coming-soon-title"
          class="font-poppins font-medium text-xl leading-7 text-ld-neutral-700 m-0"
        >
          {{ t('originationComingSoonTitle') }}
        </h2>
        <p id="origination-coming-soon-message" class="font-dm font-normal text-sm leading-5 text-ld-neutral-500 m-0">
          {{ t('originationComingSoonMessage') }}
        </p>
      </div>
      <ul id="origination-coming-soon-features" class="flex flex-col gap-4 m-0 p-0 list-none">
        @for (feature of features; track feature.id) {
          <li [id]="'origination-coming-soon-feature-' + feature.id" class="flex items-center gap-3">
            <ld-svg-icon
              [id]="'origination-coming-soon-feature-icon-' + feature.id"
              [src]="feature.icon"
              aria-hidden="true"
              class="w-5 h-5 shrink-0 text-ld-primary"
            />
            <span
              [id]="'origination-coming-soon-feature-label-' + feature.id"
              class="font-dm font-normal text-base leading-6 text-ld-neutral-700"
            >
              {{ t(feature.labelKey) }}
            </span>
          </li>
        }
      </ul>
    </div>

    <div id="origination-coming-soon-cta" class="flex flex-col gap-4 rounded-card bg-ld-neutral-700 px-6 py-6">
      <div id="origination-coming-soon-cta-text" class="flex flex-col gap-1">
        <h3 id="origination-coming-soon-cta-title" class="font-poppins font-medium text-xl leading-7 text-white m-0">
          {{ t('originationComingSoonCtaTitle') }}
        </h3>
        <p id="origination-coming-soon-cta-message" class="font-dm font-normal text-sm leading-5 text-white m-0">
          {{ t('originationComingSoonCtaMessage') }}
        </p>
      </div>
      <button
        id="origination-coming-soon-continue-btn"
        type="button"
        class="flex w-full items-center justify-center gap-2 rounded-[28px] border-none bg-ld-lime px-6 py-3 font-dm text-base font-bold uppercase text-ld-neutral-700 cursor-pointer transition-opacity duration-200 hover:opacity-90 active:opacity-80 focus-visible:outline-2 focus-visible:outline-ld-lime focus-visible:outline-offset-2"
        (click)="onContinue()"
      >
        <ld-svg-icon
          id="origination-coming-soon-continue-icon"
          [src]="externalLinkIcon"
          aria-hidden="true"
          class="w-5 h-5 shrink-0"
        />
        <span id="origination-coming-soon-continue-label">{{ t('originationComingSoonContinueButton') }}</span>
      </button>
    </div>
  </div>
</ng-container>
